module.exports = __webpack_public_path__ + "media/home/Home-ArtBooks-38183487.png";